import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-formulario-factura-formula',
  templateUrl: './formulario-factura-formula.component.html',
  styleUrls: ['./formulario-factura-formula.component.scss']
})
export class FormularioFacturaFormulaComponent {

  booleanFlag: boolean;

  constructor(public dialogRef: MatDialogRef<FormularioFacturaFormulaComponent>) {}
  
  formRegisterCantidad = new FormGroup({
    cantidad: new FormControl(),
  });

  cerrarDialogo() {
    this.dialogRef.close();
  }

  submit() {
    const { cantidad } = this.formRegisterCantidad.value;
    this.cerrarDialogo();
  }

}
